import {btn, comp, Component, cookies, fieldset, menu, router, tbar} from "@intermesh/goui";
import {t, translate, Translate} from "./util/Translate.js";
import {CurrentSection} from "./services/CurrentSection.js";
import {SectionAuth} from "./SectionAuth.js";
import {LanguageEntity, languagesStore} from "./data/LanguagesStore.js";
import {CurrentUser} from "./services/CurrentUser.js";
import {ServerApi} from "./util/ServerApi.js";

export class LanguageSelect extends Component {

	private sectionLbl: Component;

	constructor() {
		super("section");
		this.itemId = "language-select";
		this.id = "language-select";
		this.cls = "card";

		// In case we go back from Arabic or Urdu
		document.dir = "ltr";

		const fs = fieldset({
				cls: "",
			},
			comp({
				tagName: "div",
				cls: "ifw-title-cnt"
			}),
			comp(
				{
					cls: "hbox"
				},
				comp({
					tagName: "h3",
					cls: "ifw-title",
					text: "Welcome",
					flex: 1
				}),
				this.sectionLbl = comp({
					hidden: true,
					id: "sectionLbl",
					text: "sectionLbl",
					style: {
						height: "36px",
						// paddingTop: "14px",
						lineHeight: "36px",
						textAlign: "right",
						verticalAlign: "middle"
					}
				}),
				btn({
					icon: "domain",
					cls: "fablike",
					handler: (_btn) => {
						const dlg = new SectionAuth();
						dlg.on("close", async () => {
							await CurrentSection.readIf();
							const pc =JSON.parse(localStorage.getItem("portalConfig")!);
							let backgroundUrl = undefined, logoUrl = undefined;
							let cs = CurrentSection.get();

							this.sectionLbl.hidden = true;
							if (cs) {
								if(cs.frontendBackground) {
									backgroundUrl = 'elearning/frontend/sections/' + cs.id + '/background';
								}
								if (cs.frontendLogo) {
									logoUrl = 'elearning/frontend/sections/' + cs.id + '/logo';
								}
								this.sectionLbl.hidden = false;
								this.sectionLbl.text = cs.name;
								if (cookies.get("useSignin")) {
									this.sectionLbl.text += " " + t("Visitor registration");
								}
							} else {
								if (pc.defaultBackgroundBlob) {
									backgroundUrl = "webclient/background";
								}
								if (pc.defaultLogoBlob) {
									logoUrl = "webclient/logo";
								}
							}
							if (backgroundUrl) {
								document.body.style.backgroundImage = "url("+ServerApi.url(backgroundUrl, {}, true)+")";
							}
							if (logoUrl) {
								(document.getElementById("logo") as HTMLImageElement).src = ServerApi.url(logoUrl, {}, true);
							}

						});
						dlg.show();
					}
				})
			),


			comp({
				tagName: "h4",
				cls: "ifw-subtitle",
				text: "Select your language",
			}),
		);

		languagesStore.load().then((result: LanguageEntity[]) => {
			let languageBtns = [];
			for (const l of result) {
				const imgSrc = "resources/flags/" + l.key.toLowerCase() + ".svg";
				languageBtns.push(btn({
						cls: "ifw-language-btn",
						flex: 1,
						html: `<img src="${imgSrc}" alt="${t("lang" + l.key)}" class="go-avatar small">${t("lang" + l.key)}`,
						handler: async () => {
							this.handleLanguageSelect(l);
						}
					})
				);

			}
			fs.items.add(menu({cls: "ifw-language-select"}, ...languageBtns));
		});
		this.items.add(fs);

		const portalConfig = JSON.parse(localStorage.getItem("portalConfig")!);

		if (portalConfig && portalConfig.mayUseEva) {
			let evaPortal = sessionStorage.getItem("evaPortal");

			if (evaPortal) {
				CurrentUser.enableIdleLogout();

				this.items.add(tbar({style: {marginBottom: "12px"}},
						btn({
							icon: "arrow_back",
							text: t("Terug"),
							handler: () => {
								window.location.href = CurrentUser.evaPortalUrl() ?? "/";
							}
						})
					)
				)
			}
		}


		this.on("render", async () => {
			await CurrentUser.readIf();
			const cs = await CurrentSection.readIf();
			if (cs && cookies.get("sectionAuth")) {
				this.sectionLbl.hidden = false;
				this.sectionLbl.text = cs.name;
				if (cookies.get("useSignin")) {
					this.sectionLbl.text += " " + t("Visitor registration");
				}
			}
		});
	}

	private async handleLanguageSelect(l: LanguageEntity) {
		sessionStorage.setItem("language", l.key); // For the Heineken workflow
		sessionStorage.setItem("languageId", l.id); // For the Heineken workflow
		localStorage.setItem("lang_"+l.id, JSON.stringify(l));
		await translate.load();
		if (l.pleaseEnterCredentials) {
			Translate.overrideTranslation(l.key, 'Please enter your username and password', l.pleaseEnterCredentials);
		}
		if (l.credentialCheck) {
			Translate.overrideTranslation(l.key, 'Do you have an account', l.credentialCheck);
		}

		const rtlLangs = ['AR', 'UR'];
		document.dir = rtlLangs.indexOf(l.key) > -1 ? "rtl" : 'ltr';
		await this.route(l);
	}

	public async route(l: LanguageEntity) {
		const s = await CurrentSection.readIf(),
			pc = JSON.parse(localStorage.getItem("portalConfig")!);
		if (s.name && cookies.get("useSignin")) {
			// We are in signin / signoff mode now. Log out pls...
			cookies.unset("accessToken");
			document.location = "signin.php";
		} else if (pc.generateCredentials && s.name) {
			// Shortened workflow: skip welcome screen, move directly to participant form!
			// Also, log them out by definition by removing the cookie "accessToken"
			cookies.unset("accessToken");
			sessionStorage.removeItem("accessToken");
			document.location = "hflow.php";
		} else if (cookies.get("accessToken")) {
			void router.goto("check-auth");
		} else if(sessionStorage.getItem("invitationToken")) {
			void router.goto("welcome");
		} else if (pc.mayRegister || s.name) {
			void router.goto("welcome");
		} else {
			if (pc.mayUseOauth) {
				cookies.set('language', l.key, undefined, "/"); // Y THO?
			}
			void router.goto("login");
		}
	}
}